// client side error code
export enum CLIENT_SIDE_ERROR_CODE {
  DYNAMIC_IMPORT_ERROR = 'DYNAMIC_IMPORT_ERROR',
  CSV_UPLOAD_ERROR = 'CSV Upload failed',
}

export class ClientError {
  client_error_code: CLIENT_SIDE_ERROR_CODE;
  message?: string;
  constructor(client_error_code: CLIENT_SIDE_ERROR_CODE, message?: string) {
    this.client_error_code = client_error_code;
    this.message = message;
  }
}
